module.exports = __webpack_public_path__ + "static/img/face2.8cfa1b0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/face2.png
// module id = f1K1
// module chunks = 1